var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"notice-modal":""}},[_c('div',{staticClass:"dim"}),_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('a',{on:{"click":function($event){return _vm.$emit('resolve')}}},[_vm._v("Confirm")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }